// What a Flowrunner extensions project looks like on disk. Shared by `init` (which creates these) and
// `project/` (which reads and writes them).

export const CONFIG_FILE = 'flowrunner.json'

export const TOKEN_DIR = '.flowrunner'
export const TOKEN_FILE = `${ TOKEN_DIR }/token`

// ─── AI docs, shipped inside the installed package ───────────────────────────
// Packed by `scripts/pack-ai-docs.mjs` from the console repo's feature docs, so they are readable from a
// customer's project without it having the repo. Every path below is relative to the *installed package*.
//
// `init` writes none of these into the project: which file an agent reads, and where, is provider-specific
// (see `providers.ts`), so wiring one up is its own `init-<provider>` command.

/** Where the CLI ships instructions written for an AI agent, relative to the installed package. */
export const AI_DOCS_DIRECTORY = 'ai-docs'

/** The one shared authoring reference — how to write a service. Provider-independent. */
export const AI_INSTRUCTIONS_DIRECTORY = `${ AI_DOCS_DIRECTORY }/instructions/service-code-format`

/** Per-provider glue: agent definitions and the segment for that provider's instructions file. */
export const AI_PROVIDERS_DIRECTORY = `${ AI_DOCS_DIRECTORY }/providers`
